import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const General = ({ data, onOpenInfluencer }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Social media platform'}
        field={'socialMediaPlatform'}
        type={'link'}
        linkLabelField={'name'}
        target={'_blank'}
        href={data.link}
      />
      <DescriptionItem
        label={'Influencer'}
        field={'influencer'}
        type={'link'}
        linkLabelField={'name'}
        onValueClick={(_, influencer) => {
          onOpenInfluencer(influencer);
        }}
      />
      <DescriptionItem label={'Country'} field={'country.name'} />
      <DescriptionItem label={'Category'} field={'category.name'} />
      <DescriptionItem label={'Subcategory'} field={'subCategory.name'} />
      <DescriptionItem label={'Description'} field={'description'} />
    </DescriptionList>
  );
};

export default General;
